
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class MemberTermsContent extends Vue {
  private closeModal(name: string) {
    this.$modal.hide(name);
  }
}
